const GOOGLE_PLAY_ICON = [
  {
    src: new URL(
      '~/public/assets/images/icons/googlePlayIcon.png',
      import.meta.url
    ).href,
    alt: 'Google Play',
    as: 'image/png'
  }
]

export default GOOGLE_PLAY_ICON
